import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryNav() {
  const handleClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <section className="w-full px-4 md:px-6 py-12 md:py-16">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            内容分类导航
          </h2>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto">
            六大精品分类，涵盖影视、文学、音乐、科技、生活与历史人文，满足您的多元内容需求
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              onClick={handleClick}
              className="group flex flex-col items-center p-5 rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-300/50 hover:bg-primary-50/50 transition-all cursor-pointer"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-all mb-3">
                <i className={`${cat.icon} text-xl`}></i>
              </div>
              <span className="font-heading text-sm font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                {cat.name}
              </span>
              <span className="text-xs text-foreground-500 mt-1 text-center">
                {cat.description.slice(0, 12)}...
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}